module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-plus-fill-a51ced0a.svg";